import React, { useEffect, useState } from 'react';

export default function BackToTop() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const updateProgress = () => {
      const scrollY = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const progress = (scrollY / docHeight) * 100;
      setScrollProgress(progress);

      // Show or hide the button based on scroll position
      if (scrollY > 50) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', updateProgress);

    // Cleanup function
    return () => {
      window.removeEventListener('scroll', updateProgress);
    };
  }, []);

  // Function to smoothly scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="paginacontainer">
      <div 
        className={`progress-wrap ${visible ? 'active-progress' : ''}`} 
        onClick={scrollToTop}
      >
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path 
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{ strokeDasharray: '307.9', strokeDashoffset: 307.9 - (307.9 * scrollProgress) / 100 }}
          />
        </svg>
      </div>
    </div>
  );
}
